import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { routes } from 'constants/routes'
import { useCurrentUser } from 'hooks'
import { isInternalOrganizationPlan } from 'utils/organizationPlan'

type RequireInternalPlanProps = {
  children: ReactNode
}

/**
 * INTERNAL プラン（自社利用）の組織のみ公式LINE一括作成画面へのアクセスを許可する。
 */
export function RequireInternalPlan({ children }: RequireInternalPlanProps) {
  const { data: user, isLoading } = useCurrentUser()

  if (isLoading) {
    return null
  }

  if (!isInternalOrganizationPlan(user?.organizationPlan)) {
    return <Navigate to={routes.HOME} replace />
  }

  return <>{children}</>
}
